export default "That's right, they're called large language models or LLMs for short.\n"